import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { featuredCollections } from '@/mocks/home';

export default function FeaturedCollections() {
  return (
    <section id="collections" className="border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="编辑部整理"
          icon="ri-book-shelf-line"
          title="爱黑料网精选合集"
          desc="每一套都单独归过档、去过重，点开就能从头看到尾，不用再自己拼时间线。"
          action="浏览全部合集"
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featuredCollections.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative h-44 w-full overflow-hidden">
                  <img
                    src={item.cover}
                    alt={`${item.title}封面`}
                    title={`${item.title} · 爱黑料网精选合集`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  {item.hot ? (
                    <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-1 text-xs font-medium text-background-50">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-fire-fill text-[12px]"></i>
                      </span>
                      正在热议
                    </span>
                  ) : null}
                  <span className="absolute bottom-3 right-3 rounded-md bg-foreground-950/70 px-2 py-1 text-xs text-background-50 backdrop-blur-sm">
                    {item.count} 张图文
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-4 md:p-5">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

                  <div className="mt-3 flex flex-wrap gap-2">
                    {item.tags.map((tag) => (
                      <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                    <span className="text-xs text-foreground-400">更新于 {item.updated}</span>
                    <button
                      type="button"
                      className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50"
                    >
                      查看合集
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-arrow-right-line text-[13px]"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}